import _defineProperty from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { ConsoleLogger, getCredentialsForIdentity } from '@aws-amplify/core';
import { assertIdentityPoolIdConfig } from '@aws-amplify/core/internals/utils';
import { AuthError } from '../../../errors/AuthError.mjs';
import { getRegionFromIdentityPoolId } from '../utils/clients/CognitoIdentityProvider/utils.mjs';
import { assertIdTokenInAuthTokens } from '../utils/types.mjs';
import { cognitoIdentityIdProvider } from './IdentityIdProvider.mjs';
import { formLoginsMap } from './utils.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var logger = new ConsoleLogger('CognitoCredentialsProvider');
var CREDENTIALS_TTL = 50 * 60 * 1000; // 50 min, can be modified on config if required in the future

var CognitoAWSCredentialsAndIdentityIdProvider = /*#__PURE__*/function () {
  function CognitoAWSCredentialsAndIdentityIdProvider(identityIdStore) {
    _classCallCheck(this, CognitoAWSCredentialsAndIdentityIdProvider);

    this._nextCredentialsRefresh = 0;
    this._identityIdStore = identityIdStore;
  }

  _createClass(CognitoAWSCredentialsAndIdentityIdProvider, [{
    key: "clearCredentialsAndIdentityId",
    value: function () {
      var _clearCredentialsAndIdentityId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.debug('Clearing out credentials and identityId');
                this._credentialsAndIdentityId = undefined;
                _context.next = 4;
                return this._identityIdStore.clearIdentityId();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function clearCredentialsAndIdentityId() {
        return _clearCredentialsAndIdentityId.apply(this, arguments);
      }

      return clearCredentialsAndIdentityId;
    }()
  }, {
    key: "clearCredentials",
    value: function () {
      var _clearCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logger.debug('Clearing out in-memory credentials');
                this._credentialsAndIdentityId = undefined;

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function clearCredentials() {
        return _clearCredentials.apply(this, arguments);
      }

      return clearCredentials;
    }()
  }, {
    key: "getCredentialsAndIdentityId",
    value: function () {
      var _getCredentialsAndIdentityId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(getCredentialsOptions) {
        var isAuthenticated, tokens, authConfig, forceRefresh, tokenHasChanged, identityId;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isAuthenticated = getCredentialsOptions.authenticated;
                tokens = getCredentialsOptions.tokens;
                authConfig = getCredentialsOptions.authConfig;
                _context3.prev = 3;
                assertIdentityPoolIdConfig(authConfig === null || authConfig === void 0 ? void 0 : authConfig.Cognito);
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](3);
                return _context3.abrupt("return");

              case 10:
                if (!(!isAuthenticated && !authConfig.Cognito.allowGuestAccess)) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return");

              case 12:
                forceRefresh = getCredentialsOptions.forceRefresh;
                tokenHasChanged = this.hasTokenChanged(tokens);
                _context3.next = 16;
                return cognitoIdentityIdProvider({
                  tokens: tokens,
                  authConfig: authConfig.Cognito,
                  identityIdStore: this._identityIdStore
                });

              case 16:
                identityId = _context3.sent;

                // Clear cached credentials when forceRefresh is true OR the cache token has changed
                if (forceRefresh || tokenHasChanged) {
                  this.clearCredentials();
                }

                if (isAuthenticated) {
                  _context3.next = 22;
                  break;
                }

                return _context3.abrupt("return", this.getGuestCredentials(identityId, authConfig.Cognito));

              case 22:
                assertIdTokenInAuthTokens(tokens);
                return _context3.abrupt("return", this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId));

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 7]]);
      }));

      function getCredentialsAndIdentityId(_x) {
        return _getCredentialsAndIdentityId.apply(this, arguments);
      }

      return getCredentialsAndIdentityId;
    }()
  }, {
    key: "getGuestCredentials",
    value: function () {
      var _getGuestCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(identityId, authConfig) {
        var region, clientResult, res, identityIdRes;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false)) {
                  _context4.next = 3;
                  break;
                }

                logger.info('returning stored credentials as they neither past TTL nor expired.');
                return _context4.abrupt("return", this._credentialsAndIdentityId);

              case 3:
                // Clear to discard if any authenticated credentials are set and start with a clean slate
                this.clearCredentials();
                region = getRegionFromIdentityPoolId(authConfig.identityPoolId); // use identityId to obtain guest credentials
                // save credentials in-memory
                // No logins params should be passed for guest creds:
                // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html

                _context4.next = 7;
                return getCredentialsForIdentity({
                  region: region
                }, {
                  IdentityId: identityId
                });

              case 7:
                clientResult = _context4.sent;

                if (!(clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey)) {
                  _context4.next = 17;
                  break;
                }

                this._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
                res = {
                  credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                  },
                  identityId: identityId
                };
                identityIdRes = clientResult.IdentityId;

                if (identityIdRes) {
                  res.identityId = identityIdRes;

                  this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: 'guest'
                  });
                }

                this._credentialsAndIdentityId = _objectSpread(_objectSpread({}, res), {}, {
                  isAuthenticatedCreds: false
                });
                return _context4.abrupt("return", res);

              case 17:
                throw new AuthError({
                  name: 'CredentialsNotFoundException',
                  message: "Cognito did not respond with either Credentials, AccessKeyId or SecretKey."
                });

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getGuestCredentials(_x2, _x3) {
        return _getGuestCredentials.apply(this, arguments);
      }

      return getGuestCredentials;
    }()
  }, {
    key: "credsForOIDCTokens",
    value: function () {
      var _credsForOIDCTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(authConfig, authTokens, identityId) {
        var logins, region, clientResult, _authTokens$idToken, res, identityIdRes;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true)) {
                  _context5.next = 3;
                  break;
                }

                logger.debug('returning stored credentials as they neither past TTL nor expired.');
                return _context5.abrupt("return", this._credentialsAndIdentityId);

              case 3:
                // Clear to discard if any unauthenticated credentials are set and start with a clean slate
                this.clearCredentials();
                logins = authTokens.idToken ? formLoginsMap(authTokens.idToken.toString()) : {};
                region = getRegionFromIdentityPoolId(authConfig.identityPoolId);
                _context5.next = 8;
                return getCredentialsForIdentity({
                  region: region
                }, {
                  IdentityId: identityId,
                  Logins: logins
                });

              case 8:
                clientResult = _context5.sent;

                if (!(clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey)) {
                  _context5.next = 18;
                  break;
                }

                res = {
                  credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                  },
                  identityId: identityId
                }; // Store the credentials in-memory along with the expiration

                this._credentialsAndIdentityId = _objectSpread(_objectSpread({}, res), {}, {
                  isAuthenticatedCreds: true,
                  associatedIdToken: (_authTokens$idToken = authTokens.idToken) === null || _authTokens$idToken === void 0 ? void 0 : _authTokens$idToken.toString()
                });
                this._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
                identityIdRes = clientResult.IdentityId;

                if (identityIdRes) {
                  res.identityId = identityIdRes;

                  this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: 'primary'
                  });
                }

                return _context5.abrupt("return", res);

              case 18:
                throw new AuthError({
                  name: 'CredentialsException',
                  message: "Cognito did not respond with either Credentials, AccessKeyId or SecretKey."
                });

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function credsForOIDCTokens(_x4, _x5, _x6) {
        return _credsForOIDCTokens.apply(this, arguments);
      }

      return credsForOIDCTokens;
    }()
  }, {
    key: "isPastTTL",
    value: function isPastTTL() {
      return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
  }, {
    key: "hasTokenChanged",
    value: function hasTokenChanged(tokens) {
      var _this$_credentialsAnd, _tokens$idToken;

      return !!tokens && !!((_this$_credentialsAnd = this._credentialsAndIdentityId) !== null && _this$_credentialsAnd !== void 0 && _this$_credentialsAnd.associatedIdToken) && ((_tokens$idToken = tokens.idToken) === null || _tokens$idToken === void 0 ? void 0 : _tokens$idToken.toString()) !== this._credentialsAndIdentityId.associatedIdToken;
    }
  }]);

  return CognitoAWSCredentialsAndIdentityIdProvider;
}();

export { CognitoAWSCredentialsAndIdentityIdProvider };